import PhotoCarousel from './PhotoCarousel';
import FileSlider from './FileSlider';

export default { PhotoCarousel, FileSlider };
